<template>
  <section
    class="page-container"
    @click="is_select = false">
    <div
      class="mg-b-5 flex flex-align-center flex-sb-center pd-b-20">
      <div class="flex flex-align-center">
        <div
          v-if="isList"
          class="mg-r-10">
          <v-button
            gray
            stop
            @click="handleSelect('is_select')">{{selectName}}
            <i
              class="el-icon-caret-bottom"></i>
          </v-button>
          <v-select-list
            v-model="is_select"
            :list="productTypeList"
            @select="handleSelectPolicy"
          ></v-select-list>
        </div>
        <div class="flex-platform">
          <v-radio-group
            v-model="merchant_platform"
            button
            :list="serverTypeOption"
            @change="filterData">
            <template v-slot:default="{item}">
              <span class="flex-align-center">
                <span
                  v-if="item.id"
                  class="table-icon__img">
                  <img :src="getOptionName('serverTypeIcon',item.id)" >
                </span>
                <span>{{item.name}}</span>
              </span>
            </template>
          </v-radio-group>
        </div>
      </div>
      <template  v-if="isList">
        <div
          v-if="paymentNum > 0"
          class="payment-tips pointer payment-tips__top"
          @click="toQuoteList">
          <div class="left">
            <font-awesome-icon
              icon="magnifying-glass-dollar"
              class="tips-icon"></font-awesome-icon>
            {{paymentNum}}  quote(s) need to approve
          </div>
          <div class="right">
            <font-awesome-icon
              icon="chevron-right"
              class="tips-icon"></font-awesome-icon>
          </div>

        </div>
        <div
          class="flex">
          <span class="mg-r-8">
            <v-button
              type="plain"
              size="mini"
              @click="handlerToExportList"
            >Export List
            </v-button></span>
          <span>
            <v-button
              type="plain"
              size="mini"
              :disabled="isDisable"
              @click="handlerDown"
            >Export Excel
            </v-button>
          </span>
        </div>
      </template>
    </div>


    <div
      v-if="paymentMobileNum>0"
      class="payment-tips pointer"
      @click="toQuoteMobileList">
      <div class="left">
        <font-awesome-icon
          icon="bars"
          class="tips-icon"></font-awesome-icon>
        There are {{paymentMobileNum}} Campaigns that need to "Mark as issuing"
      </div>
      <div class="right">
        <font-awesome-icon
          icon="chevron-right"
          class="tips-icon"></font-awesome-icon>
      </div>

    </div>
    <div class="filter-top flex">
      <div
        v-if="isList"
        class="mg-r-10">
        <v-button
          gray
          stop
          @click="handleSelect('is_search_type')">{{selectSearchTypeName}}
          <i
            class="el-icon-caret-bottom"></i>
        </v-button>
        <v-select-list
          v-model="is_search_type"
          :list="searchTypeList"
          @select="handleSelectSearchType"
        ></v-select-list>
      </div>
      <v-input
        v-model="search"
        :prefixIcon="'el-icon-search'"
        :placeholder="`${searchTypeName}`"
        @keyEnter="filterData" />
    </div>

    <div
      class="filter-bar pointer"
      :class="{
        'blue-bg': diff,
        'border-bottom-radius': !showFilterCard}"
      @click="handleShowFilter">
      <div class="main-left">
        <div class="left">
          <font-awesome-icon
            icon="filter"
            class="icon icon-filter"></font-awesome-icon>
          <span class="text">Filter</span>
        </div>
        <div class="filter-status">
          <span
            v-for="(item, i) in statusList"
            :key="i"
            class="status-item">
            <span class="status-title">
              {{item.title}}:
            </span>
            <span class="content">
              {{item.content}}
            </span>
          </span>
        </div>
      </div>
      <div class="right">
        <div
          v-if="diff"
          class="translucence"></div>
        <div class='right-content'>
          <font-awesome-icon
            v-show="diff"
            icon="rotate-left"
            class="icon icon-rotate pointer"
            @click.stop="resetFilter"></font-awesome-icon>
          <font-awesome-icon
            v-if="showFilterCard"
            icon="square-minus"
            class="icon pointer"
          ></font-awesome-icon>
          <font-awesome-icon
            v-else
            icon="square-plus"
            class="icon pointer"
          ></font-awesome-icon>
        </div>
      </div>
    </div>
    <div
      v-show="showFilterCard"
      class="filter-card border-bottom-radius">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-datetime-picker
              v-model="date"
              :default-time="['00:00:00', '23:59:59']"
              type="datetimerange"
              @change="filterData"></v-datetime-picker>
          </div>
          <div class="form-item">
            <span>Effective Start Date</span>
            <v-datetime-picker
              v-model="effective_date"
              :default-time="['00:00:00', '23:59:59']"
              type="datetimerange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Effective End Date</span>
            <v-datetime-picker
              v-model="effective_end_date"
              :default-time="['00:00:00', '23:59:59']"
              type="datetimerange"
              @change="filterData" />
          </div>
          <!-- <div class="form-item">
            <span>Assignee</span>
            <span>
              <v-select
                v-model="cs_id"
                icon="user-nurse"
                :clearable="true"
                :list="assgineeList"
                @change="filterData" />
            </span>
          </div> -->
          <div
            v-if="selectPrivateOrAll == 23"
            class="form-item">
            <span>
              Plan Type
              <span
                v-if="plan_type.length"
                class="all"
                @click="handlerNoneAll('plan_type')">None</span>
            </span>
            <span >
              <v-select
                v-model="plan_type"
                placeholder="All"
                multiple
                :list="planTypeList"
                @change="filterData">
                <template #default="{item}">
                  <span class="flex-align-center select-icon-center">
                    <span>{{item.name}}</span>
                  </span>
                </template>
              </v-select>
            </span>
          </div>
          <div class="form-item">
            <span>
              Insurer
              <span
                v-if="company_id.length"
                class="all"
                @click="handlerNoneAll('company_id')">None</span>
            </span>
            <span >
              <!--              <v-select-->
              <!--                v-model="company_id"-->
              <!--                placeholder="All"-->
              <!--                multiple-->
              <!--                :list="insurerList"-->
              <!--                has-icon-->
              <!--                @change="filterData">-->
              <!--                <template #default="{item}">-->
              <!--                  <span class="flex-align-center select-icon-center">-->
              <!--                    <span class="icon">-->
              <!--                      <img-->
              <!--                        v-if="getOptionData('companySmallIcon', item.id).logo"-->
              <!--                        :src="getOptionData('companySmallIcon', item.id).logo? getOptionData('companySmallIcon', item.id).logo:''"/>-->
              <!--                    </span>-->
              <!--                    <span>{{item.name}}</span>-->
              <!--                  </span>-->
              <!--                </template>-->
              <!--              </v-select>-->
              <el-select
                v-model="company_id"
                placeholder="All"
                multiple
                size="small"
                class="width-fill height-32"
                filterable
                @change="filterData">
                <el-option-group
                  v-for="group in agencyInsurerList"
                  :key="group.group"
                  :label="group.name">
                  <span class="fs-12 gray">{{group.agency_name}}</span>
                  <el-option
                    v-for="item in group.children"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    <span class="flex-align-center select-icon-center">
                      <span class="icon">
                        <img
                          v-if="getOptionData('companySmallIcon', item.id).logo"
                          :src="getOptionData('companySmallIcon', item.id).logo"/>
                      </span>
                      <span>{{item.name}}</span>
                    </span>
                  </el-option>
                </el-option-group>
              </el-select>
            </span>
          </div>
          <div class="form-item">
            <span>
              Agency
            </span>
            <v-select
              v-model="agency_search_id"
              :list="agencyStatusOption"
              placeholder="All"
              multiple
              @change="filterData">
              <template  v-slot:default="{item}">
                <span class="flex-align-center">
                  <span class="table-icon__img mg-r-8">
                    <img :src="item.agency_icon">
                  </span>
                  <span> {{item.name}}</span>
                </span>
              </template>
            </v-select>
          </div>
          <div class="form-item">
            <span>
              Channel
            </span>
            <span>
              <v-select
                v-model="source"
                :list="specialOptions.source"
                placeholder="All"
                multiple
                @change="filterData"
              />
            </span>
          </div>
          <div class="form-item">
            <span>
              Partner
              <span
                v-if="partner_filter_id.length"
                class="all"
                @click="handlerNoneAll('partner_filter_id')">None</span>
            </span>
            <span>
              <v-select
                v-model="partner_filter_id"
                placeholder="All"
                multiple
                :list="partnerList"
                @change="filterData" />
            </span>
          </div>
          <div class="form-item">
            <span>
              Referrer
            </span>
            <span>
              <v-input
                v-model="referrer_code"
                @change="filterData" />
            </span>
          </div>
        </div>
        <div
          v-if="!isSelectPrivate"
          class="filter-right">
          <div class="form-item">
            <span>
              Product Type
              <span
                class="all"
                @click="handlerSelectAll('class_id')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('class_id')">None</span>
            </span>
            <div class="flex-sb">
              <div class="half">
                <span>Auto-Quote</span>
                <v-checkbox
                  v-model="motor_select"
                  class="mg-t-8 mg-b-10"
                  :is-indeterminate="isAllMotorSelect"
                  @change="handleSelectQuote"><span class="fs-14 color-dark fw-600">Motors</span></v-checkbox>
                <v-checkbox-group
                  v-model="class_id"
                  :list="motorClassOptions"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
                <v-checkbox
                  v-model="none_motor_select"
                  class="mg-t-8 mg-b-10"
                  :is-indeterminate="isNoneMotorSelect"
                  @change="handleSelectNoneQuote"><span class="fs-14 color-dark fw-600">Non-Motors</span></v-checkbox>
                <v-checkbox-group
                  v-model="class_id"
                  :list="noneMotorClassOptions"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
                <span
                  class="display-flex flex-sb-center mg-t-10"
                  @click="isShowSMEMore=!isShowSMEMore">
                  <v-checkbox
                    v-model="sme_select"
                    class="mg-t-8 mg-b-10"
                    :is-indeterminate="isSMESelect"
                    @change="handleSelectSMEQuote"><span class="fs-14 color-dark fw-600">SME</span></v-checkbox>
                  <!--                  <span>SME</span>-->
                  <span
                    :class="isShowSMEMore?'el-icon-arrow-up':'el-icon-arrow-down'"
                  ></span>
                </span>
                <section v-show="isShowSMEMore">
                  <v-checkbox-group
                    v-model="class_id"
                    :list="sme_class_data"
                    :isColumn="false"
                    @change="filterData"></v-checkbox-group>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div
          class="filter-right"
        >
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>            </span>
            <v-checkbox-group
              v-model="stts"
              :list="statusOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="circle"
                    :class="{
                      'red': item.id == 0,
                      'orange-light': item.id == 1,
                      'yellow-dark': item.id == 2,
                      'blue': item.id == 3,
                      'green': item.id == 4
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Effectiveness
              <span
                class="all"
                @click="handlerSelectAll('effe')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('effe')">None</span>            </span>
            <v-checkbox-group
              v-model="effe"
              :list="effeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex-align-center">
                  <p class="icon icon-text">
                    <font-awesome-icon
                      icon="file-powerpoint"
                      class="icon-color fs-16"
                      :class="{
                        'gray': item.id == 1,
                        'green': item.id == 2,
                        'red': item.id == 3
                      }"/>
                  </p>
                  <span
                    class="span-options span-options__none"
                    :class="{
                      'gray': item.id == 1,
                      'green': item.id == 2,
                      'red': item.id == 3
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Consent
              <!--<span
                class="all"
                @click="handlerSelectAll('pcy_agreement_1')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('pcy_agreement_1')">None</span>-->
            </span>
            <v-checkbox-group
              v-model="pcy_agreement_1"
              :list="user_agreement_option"
              :is-column="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': item.id ==0,
                      'verified-color': item.id == 1,
                      'gray': item.id == -1,
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Account
            </span>
            <v-checkbox-group
              v-model="hav_account"
              :list="policy_account_option"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex-align-center">
                  <p class="icon icon-text">
                    <i
                      v-if="item.id==1"
                      class="el-icon-user-solid gray fs-16 icon-color"></i>
                    <i
                      v-if="item.id==2"
                      class="el-icon-user gray fs-16 icon-color"></i>
                  </p>
                  <span
                    class="span-options span-options__none gray">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div class="filter-right">

          <div class="form-item">
            <span>
              Renew Status
              <span
                class="all"
                @click="handlerSelectAll('renew_status')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('renew_status')">None</span>            </span>
            <v-checkbox-group
              v-model="renew_status"
              :list="renewOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options-2"
                    :class="{
                      'blue': item.id === 2,
                      'gold': item.id === 3,
                      'red': item.id === 4,
                      'orange': item.id === 5,
                      'gray': item.id === 1,
                      'green': item.id === 7,
                      'big-red': item.id ===6,
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div
            v-if="selectPrivateOrAll==11"
            class="form-item">
            <span>
              Extract Benefits
              <span
                class="all"
                @click="handlerSelectAll('extra_benefit_arr')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('extra_benefit_arr')">None</span>
            </span>
            <v-checkbox-group
              v-model="extra_benefit_arr"
              :list="extra_benefits_list"
              :isColumn="false"
              @change="filterData">
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Auto Renew
              <span
                class="all"
                @click="handlerSelectAll('auto_renewal_tag ')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('auto_renewal_tag ')">None</span>            </span>
            <v-checkbox-group
              v-model="auto_renewal_tag "
              :list="auto_renewal_tag_list "
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gold': [2].includes(item.id),
                      'blue': [4].includes(item.id),
                      'black': [1].includes(item.id),
                      'red': [3].includes(item.id),
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Client Option
              <span
                class="all"
                @click="handlerSelectAll('auto_renewal')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('auto_renewal')">None</span>            </span>
            <v-checkbox-group
              v-model="auto_renewal"
              :list="auto_renewal_list"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options-2"
                    :class="{
                      'black': item.id === 2,
                      'green': item.id === 1
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div
          class="filter-last"
        >
          <div class="form-item">
            <span>
              Tags
              <span
                class="all"
                @click="handlerSelectAll('tags')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('tags')">None</span>            </span>
            <v-checkbox-group
              v-model="tags"
              :list="tagsOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gold': [1].includes(item.id),
                      'yellow-dark': [16384].includes(item.id),
                      'blue': [2,16,64,256].includes(item.id),
                      'orange': item.id == 4,
                      'black': [8,32,128].includes(item.id),
                      'red': [512].includes(item.id),
                      'gray': [1024, 2048].includes(item.id),
                      'green': [32768].includes(item.id)
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="handleTableClass"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template #default="{ row }">
            <div class="flex-column  flex-align-center">
              <span
                v-if="row.merchant_platform"
                class="table-icon__img">
                <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
              </span>
              <span
                v-tooltip="row.agency_name"
                class="table-icon__img mg-t-8">
                <img
                  :src="getAgencyIcon(row.agency_id)">
              </span>
              <p class="icon icon-text mg-t-8">
                <font-awesome-icon
                  icon="file-powerpoint"
                  class="icon-color fs-16"
                  :class="{
                    'gray': row.effectiveness == 1,
                    'green': row.effectiveness == 2,
                    'red': row.effectiveness == 3
                  }"/>
              </p>

            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95px"
        >
          <template
            #header="{column, $index}"
          >
            <span
              class="pointer"
              @click="handleSort(1,column, $index)">
              <span  :class="{'blue':sort==2}">Updated</span>
              <font-awesome-icon
                v-if="sort==1"
                class="mg-l-8"
                icon="arrow-down"></font-awesome-icon>
            </span>
          </template>
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
            <p class="channel">{{row.source_language}}</p>
            <p class="channel">{{row.partner_language}}</p>
          </template>

        </el-table-column>
        <el-table-column
          :width="selectPrivateOrAll==11?0:70"
          prop="id"
        >
          <template #default="{ row }">
            <!--            <span class="button-border">{{row.type_language}}</span>-->
            <div
              v-if="selectPrivateOrAll!=11"
              class="flex-algin">
              <span>
                <div class="flex  table-icon">
                  <div v-if="row.company_id">
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                      >
                    </span>
                  </div>
                  <div>
                    <span
                      v-tooltip="row.class_language"
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        v-if="row.class_id&& row.product_id!==80||row.sme_versions==3"
                        :icon="getOptionName('iconOptions', row.class_id)" />
                      <font-awesome-icon
                        v-else
                        icon="cube" />
                    </span>
                  </div>
                </div>
                <div
                  v-if="row.product_id!==80"
                  class="flex table-icon margin-top-flex">
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(2)) && extra_show(row.extra_benefits_content,2)==2"
                      v-tooltip="extra_tip(row.extra_benefits_content,2)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="wind" />
                    </span>
                  </div>
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(1)) && extra_show(row.extra_benefits_content,1)==1"
                      v-tooltip="extra_tip(row.extra_benefits_content,1)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="user-injured" />
                    </span>
                  </div>
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(4)) && extra_show(row.extra_benefits_content,4)==4"
                      v-tooltip="extra_tip(row.extra_benefits_content,4)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="key" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :width="selectPrivateOrAll==11?360:''"
          label="Policy">
          <template #default="{ row }">
            <div
              class="flex-algin"
              @click="rowClick(row)" >
              <router-link
                class="showLick"
                :to="rowClickFn(row)">
                <span class="span-label">{{ row.insurer }} {{  80>row.class_id>50?row.product_type:row.plan}}</span>
              </router-link>
              <template v-if="selectPrivateOrAll!=11">
                <p
                  v-if="row.pcy_no||row.cvr_nt_no"
                  class="phone-text">
                  <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
                  <span  v-if="row.cvr_nt_no"><span class="weight-text">CN# </span> {{ row.cvr_nt_no }}</span>
                </p>
              </template>
              <span
                v-if="row.order_sn"
                class="phone-text">
                <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
              </span>
              <template v-if="selectPrivateOrAll==11">
                <div
                  class="flex-algin">
                  <span>
                    <div class="flex  table-icon">
                      <div v-if="row.company_id">
                        <span
                          v-tooltip="row.company_language"
                          class="icon icon-content"
                        >
                          <img
                            :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                          >
                        </span>
                      </div>
                      <div>
                        <span
                          v-tooltip="row.class_language"
                          class="icon icon-content"
                        >
                          <font-awesome-icon
                            v-if="row.class_id&& row.product_id!==80"
                            :icon="getOptionName('iconOptions', row.class_id)" />
                          <font-awesome-icon
                            v-else
                            icon="cube" />
                        </span>
                      </div>
                      <p
                        v-if="row.pcy_no||row.cvr_nt_no"
                        class="phone-text">
                        <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
                        <span  v-if="row.cvr_nt_no"><span class="weight-text">CN# </span> {{ row.cvr_nt_no }}</span>
                      </p>
                    </div>

                    <div
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(2)) && extra_show(row.extra_benefits_content,2)==2"
                      class="flex  table-icon margin-top-flex">
                      <div v-if="row.company_id">
                        <span
                          v-tooltip="extra_data(row.extra_benefits_content,2).company_language"
                          class="icon icon-content"
                        >
                          <img
                            v-if="extra_data"
                            :src="getOptionData('companySmallIcon', extra_data(row.extra_benefits_content,2).company_id).logo"
                          >
                        </span>
                      </div>
                      <div>
                        <span
                          v-tooltip="extra_tip(row.extra_benefits_content,2)"
                          class="icon icon-content backgroud-width"
                        >
                          <font-awesome-icon
                            icon="wind" />
                        </span>
                      </div>
                      <p
                        v-if="extra_data(row.extra_benefits_content,2).pcy_no"
                        class="phone-text">
                        <span ><span class="weight-text">Policy No. </span> {{ extra_data(row.extra_benefits_content, 2).pcy_no }}</span>
                      </p>
                    </div>
                    <div
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(1)) && extra_show(row.extra_benefits_content,1)==1"
                      class="flex  table-icon margin-top-flex">
                      <div v-if="row.company_id">
                        <span
                          v-tooltip="extra_data(row.extra_benefits_content,1).company_language"
                          class="icon icon-content"
                        >
                          <img
                            v-if="extra_data"
                            :src="getOptionData('companySmallIcon', extra_data(row.extra_benefits_content,1).company_id).logo"
                          >
                        </span>
                      </div>
                      <div>
                        <span
                          v-tooltip="extra_tip(row.extra_benefits_content,1)"
                          class="icon icon-content backgroud-width"
                        >
                          <font-awesome-icon
                            icon="user-injured" />
                        </span>
                      </div>
                      <p
                        v-if="extra_data(row.extra_benefits_content,1).pcy_no"
                        class="phone-text">
                        <span ><span class="weight-text">Policy No. </span> {{ extra_data(row.extra_benefits_content, 1).pcy_no }}</span>
                      </p>
                    </div>
                    <div
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(4)) && extra_show(row.extra_benefits_content,4)==4"
                      class="flex  table-icon margin-top-flex">
                      <div v-if="row.company_id">
                        <span
                          v-tooltip="extra_data(row.extra_benefits_content,4).company_language"
                          class="icon icon-content"
                        >
                          <img
                            v-if="extra_data"
                            :src="getOptionData('companySmallIcon', extra_data(row.extra_benefits_content,4).company_id).logo"
                          >
                        </span>
                      </div>
                      <div>
                        <span
                          v-tooltip="extra_tip(row.extra_benefits_content,4)"
                          class="icon icon-content backgroud-width"
                        >
                          <font-awesome-icon
                            icon="key" />
                        </span>
                      </div>
                      <p
                        v-if="extra_data(row.extra_benefits_content,4).pcy_no"
                        class="phone-text">
                        <span ><span class="weight-text">Policy No. </span> {{ extra_data(row.extra_benefits_content, 4).pcy_no }}</span>
                      </p>
                    </div>
                  </span>
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150px"
          label="Premium">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">{{ row.gross  }}</p>
              <p class="first-text">({{ row.payable  }})</p>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          width="150px"-->
        <!--          label="Agency">-->
        <!--          <template #default="{ row }">-->
        <!--            <div class="flex-algin">-->
        <!--              <span class="first-text">{{ row.agency_nickname }}</span>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <el-table-column
          width="105px"
          label="Summary">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text summary">{{ row.description }} </p>
              <span v-if="row.rgtn_no">
                <span class="summary_rgtn_no">{{ row.rgtn_no }} </span>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.policy_holder }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"><i :class="row.customer_id>0?'el-icon-user-solid':'el-icon-user'"/> {{ row.phone_no }}</span>
              </span>
              <p v-if="[0,1].includes(row.pcy_agreement_1)">
                <span class="flex flex-align-center">
                  <font-awesome-icon
                    icon="square-check"
                    class="mg-r-3 fs-12"
                    :class="{'pending_verify-color':row.pcy_agreement_1==0,'verified-color':row.pcy_agreement_1==1} "></font-awesome-icon>
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': row.pcy_agreement_1==0,
                      'verified-color': row.pcy_agreement_1==1,
                    }">{{getOptionName('user_agreement_option',row.pcy_agreement_1) }}</span>
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="89px"
          label="Referrer"
          prop="referrer_nm">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">
                <span
                  v-if="row.referrer_id != 0 && row.referrer_nm.trim() === ''"
                  class="unname">Unnamed</span>
                <span v-if="row.referrer_id != 0">{{ row.referrer_nm }}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          prop=""
        >
          <template  #header="{column, $index}">
            <span
              class="pointer"
              @click="handleSort(2)">
              <span :class="{'blue':sort==1}">Period</span>
              <font-awesome-icon
                v-if="sort==2"
                class="mg-l-8"
                icon="arrow-down"></font-awesome-icon>
            </span>
          </template>
          <template #default="{ row }">
            <div class="flex-algin period-text">
              <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span>
              <span> {{ row.policy_period.split(" - ")[1] }}</span>
              <span
                v-if="row.is_eff_dt_delay && row.stts != 425"
                class="asap">ASAP</span>
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="155px"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.stts),
                    'orange': [401, 301].includes(row.stts),
                    'yellow-dark': [410, 501, 701].includes(row.stts),
                    'blue': [420, 505, 705].includes(row.stts),
                    'green': [425, 510, 710].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': v.id == 1,
                    'yellow-dark': v.id == 16384,
                    'blue': [2,16,64,256].includes(v.id),
                    'orange': v.id == 4,
                    'black': [8,32,128].includes(v.id),
                    'red': [512].includes(v.id),
                    'gray': [1024, 2048].includes(v.id),
                    'green': [32768].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="selectPrivateOrAll==11"
          width="155px"
          label="Files">
          <template #default="{ row }">
            <span
              class="flex-align-center">
              <span
                class="circle"
                :class="{
                  'green': row.file_status&&row.file_status.id_type_pic_path_id== 1,
                  'red': row.file_status&&row.file_status.id_type_pic_path_id==0,
                  'gray': row.file_status&&row.file_status.id_type_pic_path_id==-1,
                }"></span>
              <span>Insured</span>
            </span>
            <span
              class="flex-align-center">
              <span
                class="circle"
                :class="{
                  'green': row.file_status&&row.file_status.licence_pic_path_id== 1,
                  'red': row.file_status&&row.file_status.licence_pic_path_id==0,
                  'gray': row.file_status&&row.file_status.licence_pic_path_id==-1,
                }"></span>
              <span>Drivers</span>
            </span>
            <span
              class="flex-align-center">
              <span
                class="circle"
                :class="{
                  'green': row.file_status&&row.file_status.ncd_proof_path_id== 1,
                  'red': row.file_status&&row.file_status.ncd_proof_path_id==0,
                  'gray': row.file_status&&row.file_status.ncd_proof_path_id==-1,
                }"></span>
              <span>NCD</span>
            </span>
            <span
              class="flex-align-center">
              <span
                class="circle"
                :class="{
                  'green': row.file_status&&row.file_status.rgtn_pic_path_id== 1,
                  'red': row.file_status&&row.file_status.rgtn_pic_path_id==0,
                  'gray': row.file_status&&row.file_status.rgtn_pic_path_id==-1,
                }"></span>
              <span>VRD</span>
            </span>

          </template>
        </el-table-column>
        <el-table-column
          width="155px"
          label="Renew Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-options-2"
                  :class="{
                    'blue': row.renew_status === 2,
                    'gold': row.renew_status === 3,
                    'red': row.renew_status === 4,
                    'orange': row.renew_status === 5,
                    'gray': row.renew_status === 1,
                    'green': row.renew_status === 7,
                    'big-red': row.renew_status === 6,
                  }">{{ getGlobalOptionName('renew_status',row.renew_status) }}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="155px"
          label="Auto Renew">
          <template #default="{ row }">
            <div class="flex-algin">
              <p
                v-if="row.auto_renewal_tag>0"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': [2].includes(row.auto_renewal_tag),
                    'blue': [4].includes(row.auto_renewal_tag),
                    'black': [1].includes(row.auto_renewal_tag),
                    'red': [3].includes(row.auto_renewal_tag),
                  }">{{ getOptionName('auto_renewal_tag_list',row.auto_renewal_tag) }}</span>
              </p>
              <p class="status-height">
                <span
                  class="span-options-2"
                  :class="{
                    'green': row.auto_renewal_on === 1,
                    'gray': row.auto_renewal_on === 2
                  }">{{ getOptionName('auto_renewal_list',row.auto_renewal_on) }}</span>
              </p>

            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <div class="transparent">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        @row-click="rowClick">
        <el-table-column
          prop="issue_dt"
          label="Issue Date & Time"></el-table-column>
        <el-table-column
          prop="pcy_id"
          label="ID"></el-table-column>
        <el-table-column
          prop="product_type"
          label="Product Type"></el-table-column>
        <el-table-column
          prop="insurer"
          label="Insurer"></el-table-column>
        <el-table-column
          prop="policy_holder"
          label="Policyholder"></el-table-column>
        <el-table-column
          prop="contact_nm"
          label="Contact Name"></el-table-column>
        <el-table-column
          prop="phone_no"
          label="Phone No."></el-table-column>
        <el-table-column
          prop="policy_period"
          label="Policy Period"></el-table-column>
        <el-table-column
          label="Status">
          <template #default="{ row }">
            <span class="span-checkbox success">{{ row.stts_language }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tickets"
          label="Tickets"></el-table-column>
      </el-table>
    </div> -->

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getPolicyDocumentList, getPolicyExportList, getPolicyList} from '@/api/policy'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
import {getOrderList} from '@/api/order'
import {getMicropolicyList} from '@api/micropolicy'
import MixinProductTypeFilter from '@/mixins/product-type-filter'

export default {
  name: 'Policy',
  mixins: [MixinOptions,MixinProductTypeFilter],
  props:{
    isFulfilled:{
      type:Boolean,
      default:false
    },
    isList:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      selectPrivateOrAll:0,
      sort:1,
      merchant_platform:'',
      is_select:false,
      is_search_type:false,
      search_type:'',
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      // todo
      date: [],
      effective_end_date: [],
      company_id: [],
      plan_type: [],
      referrer_code: '',
      class_id: [],
      category_id: [],
      stts: [1, 2, 3, 4],
      effe: [],
      tags: [],
      renew_status: [],
      agency_search_id: [],
      auto_renewal: [],
      auto_renewal_tag: [],
      cs_id: 0,
      search: '',
      tableData: [],
      statusList: [],
      showFilterCard: true,
      isShowSMEMore: false,
      source: [],
      defaultFilter:{
        date: [],
        search_type:'',
        effective_end_date: [],
        cs_id: 0,
        company_id: [],
        class_id: [],
        stts: [1, 2, 3, 4],
        effe: [],
        tags: [],
        renew_status: [],
        source: [],
        partner_filter_id: [],
        effective_date: [],
        extra_benefit_arr: [],
        agency_search_id: [],
        merchant_platform:'',
        pcy_agreement_1:[],
        hav_account: [],
        auto_renewal: [],
        auto_renewal_tag: [],
      },
      paymentNum: 0,
      paymentMobileNum: 0,
      partner_filter_id: [],
      effective_date: [],
      extra_benefit_arr: [],
      pcy_agreement_1: [],
      hav_account: [],
      motor_select:false,
      none_motor_select:false,
      sme_select:false,
    }
  },
  computed: {
    ...mapState('filter', ['selectFilterData','openFilterCar']),
    selectName(){
      let name = this.getOptionName('productTypeList',this.selectPrivateOrAll)
      return name
    },
    selectSearchTypeName(){
      let name = this.getOptionName('searchTypeList',this.search_type)
      return name
    },
    searchTypeName(){
      let arr = [...this.searchTypeList]
      arr.splice(0, 1)
      if(!this.search_type)
        return arr.map(item => item.name).join(', ')
      return this.selectSearchTypeName
    },
    filesType(){
      return {
        id_type_pic_path_id:'Insured',
        licence_pic_path_id:'Drivers',
        ncd_proof_path_id:'NCD',
        rgtn_pic_path_id:'VRD',
      }
    },
    productTypeList(){
      return [
        {
          id:0,
          name:'All Policies'
        },
        {
          id:'11',
          name:'Private Car'
        },
        {
          id:'14',
          name:'Motorcycle'
        },
        {
          id:'12',
          name:'Commercial Vehicle'
        },
        {
          id:'23',
          name:'Travel'
        },
        {
          id:'22',
          name:'Working Holiday'
        },
      ]
    },

    privateAndAll(){
      return [
        {
          name:'14',
          label:'MV'
        },
        {
          name:'11',
          label:'PV'
        },
        {
          name:'12',
          label:'CV'
        }
      ]
    },
    isSelectPrivate(){
      return this.selectPrivateOrAll != 0
    },
    isDisable(){
      return !this.date || this.date.length == 0
    },
    assgineeList(){
      let arr =[{id:0,name:'All'}]
      let {assignee=[]} = this.globalOptions||{}
      return [...arr,...assignee]
    },
    statusOptions() {
      return this.globalOptions.new_pcy_stts
    },
    effeOptions() {
      return this.globalOptions.effectiveness
    },
    policy_account_option() {
      return this.globalOptions.policy_account_option
    },
    tagsOptions() {
      return this.globalOptions.pcy_tag
    },
    renewOptions() {
      return this.globalOptions.renew_status
    },
    extra_benefits_list() {
      return this.allOptions11.extra_benefits
    },
    extra_show(){
      return (row,index)=>{
        let textData = {}
        if(!row) return ''
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        return textData.id
      }
    },
    extra_tip(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        if(textData)
          return textData.name
      }
    },
    extra_data(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1].content
        })
        return textData
      }
    },
    insurerList(){
      let arr = JSON.parse(JSON.stringify(this.insurerAllOptions))
      return arr
    },
    agencyInsurerList(){
      const allInsurers = this.insurerList
      const groups = {}
      allInsurers.forEach(item => {
        const agencyId = item.agency_id
        if (!groups[agencyId]) {
          groups[agencyId] = { agency_id: agencyId, name: item.agency_name||'Other', children: [] }
        }
        groups[agencyId].children.push({ id: item.id, name: item.name })
      })
      const result = Object.values(groups)
      return result
    },
    planTypeList(){
      let {travel_all_plan_type}= this.globalOptions||{}
      return travel_all_plan_type||[]
    },
    partnerList(){
      return this.globalOptions.policy_partner_filter || []
    },
    channelList(){
      return this.specialOptions.source||[]
    },
    diff(){
      let res = false
      Object.keys(this.defaultFilter).forEach(key => {
        let vue_data = JSON.parse(JSON.stringify(this[key]))
        let default_data = JSON.parse(JSON.stringify(this.defaultFilter[key]))
        if(Array.isArray(vue_data) && Array.isArray(default_data)){
          vue_data.sort()
          default_data.sort()
        }
        if(JSON.stringify(vue_data) != JSON.stringify(default_data)){
          res =  true
        }
      })
      return res
    },
    noneMotorClassId(){
      const data = this.noneMotorClassOptions.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      return data
    },
    SMEClassId(){
      const data = this.sme_class_data.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      return data
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        if(!this.isFulfilled){
          let {policy={}} =  this.selectFilterData||{}
          Object.keys(policy).forEach(item=>{
            this[item] = policy[item]
          })
          this.setFilterData(policy||{})
          let filterCar =  this.openFilterCar||{}
          let {showFilterCard=true} = filterCar.policy||{}
          this.showFilterCard = showFilterCard
        }

        this.isFulfilled?
          this.network().getPolicyDocumentList(): this.network().getPolicyList()
        this.network().getOrderList()
        this.network().getOrderMoibleList()
      }
    },
    date: {
      immediate: true,
      handler(val){
        this.delStatus('Created')
        if(val && val.length){
          let content = val[0] + ' - ' + val[1]
          this.addStutus('Created', content)
        }
      }
    },
    cs_id:{
      immediate: true,
      handler(val){
        this.delStatus('Assignee')
        if(val){
          let name = this.getOptionName('assigneeList',val)
          this.addStutus('Assignee', name)
        }
      }
    },
    company_id:{
      immediate: true,
      handler(val){
        this.delStatus('Insurer')
        if(val.length){
          let company = []
          val.forEach(item => {
            company.push(this.getOptionName('insurerList', item))
          })
          this.addStutus('Insurer', company.join(', '))
        }
      }
    },
    source:{
      immediate: true,
      handler(val){
        this.delStatus('Channel')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('channelList', item))
          })
          this.addStutus('Channel', status.join(', '))
        }
      }
    },
    class_id:{
      immediate: true,
      handler(val){
        this.delStatus('Product Type')
        if(val.length){
          this.addStutus('Product Type', `${val.length} Products`)
        }
      }
    },
    stts:{
      immediate: true,
      handler(val){
        this.delStatus('Status')
        if(val.length && JSON.stringify(val) != JSON.stringify(this.defaultFilter.stts)){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('statusOptions', item))
          })
          this.addStutus('Status', status.join(', '))
        }
      }
    },
    effe:{
      immediate: true,
      handler(val){
        this.delStatus('Effectiveness')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('effeOptions', item))
          })
          this.addStutus('Effectiveness', status.join(', '))
        }
      }
    },
    tags:{
      immediate: true,
      handler(val){
        this.delStatus('Tags')
        if(val.length){
          this.addStutus('Tags', `${val.length} Tags`)
        }
      }
    },
  },
  methods: {
    ...mapActions('filter', ['setFilterData','setOpenFilterCar']),
    getAgencyIcon(agency_id){
      let obj = {}
      this.agencyStatusOption.filter(item=>{
        if(item.id==agency_id)
          obj = item
      })
      return obj.agency_icon
    },
    handleSort(type,cloumn,index){
      this.sort = type
      this.network().getPolicyList()
    },
    handleTableClass(row, column, rowIndex, columnIndex){
      console.log(row, column, rowIndex, columnIndex)
      return 'tableHeader'
    },
    handleSelectPolicy({id}){
      this.selectPrivateOrAll = id
      this.pageConfig.currentPage =1
      this.network().getPolicyList()
    },
    handleSelectSearchType({id}){
      this.search_type = id
      this.is_search_type = false
      if(this.search)
      { this.pageConfig.currentPage =1
        this.network().getPolicyList()}
    },
    handleSelect(target){
      this[target] = !this[target]
    },
    handleShowFilter(){
      this.showFilterCard = !this.showFilterCard
      this.setOpenFilterCar({
        ...this.openFilterCar,
        policy:{
          showFilterCard:this.showFilterCard
        }
      })
    },
    handleClickTab(){
      // this.$router.push({
      //   name:this.activeTab,
      //   query:{
      //     customer_id: this.customerId
      //   }
      // })
    },
    handleSelectCar(){
      this.pageConfig.currentPage =1
      this.network().getPolicyList()
    },
    handlerDown() {
      this.network().getPolicyExportList()
    },
    handlerToExportList(){
      this.$router.push('/admin-cms/marketing-report?name=list')
    },
    rowClick(row) {
      const { id, product_id,pcy_id,class_id,sme_versions } = row

      //filter
      let params = {
        class_id:this.class_id,
        company_id:this.company_id,
        cs_id:this.cs_id,
        stts:this.stts,
        search: this.search,
        date:this.date,
        pageConfig:this.pageConfig,
        effe: this.effe,
        tags: this.tags,
        renew_status: this.renew_status,
        source: this.source,
        partner_filter_id: this.partner_filter_id,
        effective_date: this.effective_date,
        effective_end_date: this.effective_end_date,
        selectPrivateOrAll:this.selectPrivateOrAll,
        extra_benefit_arr:this.extra_benefit_arr,
        agency_search_id:this.agency_search_id,
        pcy_agreement_1:this.pcy_agreement_1,
        hav_account:this.hav_account,
        auto_renewal_tag:this.auto_renewal_tag,
        auto_renewal:this.auto_renewal,
        search_type:this.search_type,
      }
      if(this.selectPrivateOrAll==23){
        params.plan_type=this.plan_type
      }
      this.setFilterData({policy:params})
      let productId = product_id
      if(product_id==80)
        productId  = class_id
      this.$router.push({
        path: product_id > 50&&product_id<80? '/records/policy/manual/detail': '/records/policy/detail',
        query: {
          id,
          product_id:productId,
          // pcy_id
        }
      })
    },
    // 新标签打开链接
    rowClickFn(row){
      const { id, product_id,pcy_id,class_id,sme_versions } = row
      let productId = product_id
      if(product_id==80)
        productId  = class_id
      return({
        path: product_id > 50&&product_id<80? '/records/policy/manual/detail': '/records/policy/detail',
        query: {
          id,
          product_id:productId,
          // pcy_id,
        }
      })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'class_id':
          // origin = 'productTypeOptions'
          origin = 'all_class_data'
          break
        case 'stts':
          origin = 'statusOptions'
          break
        case 'effe':
          origin = 'effeOptions'
          break
        case 'tags':
          origin = 'tagsOptions'
          break
        case 'renew_status':
          origin = 'renewOptions'
          break
        case 'company_id':
          origin = 'insurerAllOptions'
          break
        case 'source':
          origin = 'channelList'
          break
        case 'partner':
          origin = 'partnerList'
          break
        case 'extra_benefit_arr':
          origin = 'extra_benefits_list'
          break
        case 'agency_search_id':
          origin = 'agencyStatusOption'
        case 'auto_renewal':
          origin = 'auto_renewal_list'
        case 'auto_renewal_tag':
          origin = 'auto_renewal_tag_list '
        case 'pcy_agreement_1':
          origin = 'user_agreement_option'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data

      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    filterData() {
      let arr  = this.class_id.filter(item=>[11,12,14,13,15].includes(item))||[]
      let arr_none  = this.class_id.filter(item=>this.noneMotorClassId.includes(item))||[]
      let sme_arr  = this.class_id.filter(item=>this.SMEClassId.includes(item))||[]
      if(this.motor_select){
        if(arr.length<=0)
          this.motor_select =false
      }
      if(arr.length>=3) this.motor_select = true
      if(arr_none.length>=this.noneMotorClassId.length) this.none_motor_select = true
      if(sme_arr.length>=this.SMEClassId.length) this.sme_select = true
      if(this.none_motor_select){
        if(arr_none.length<=0)
          this.none_motor_select =false
      }
      if(this.sme_select){
        if(sme_arr.length<=0)
          this.sme_select =false
      }
      this.pageConfig.currentPage = 1
      this.isFulfilled?
        this.network().getPolicyDocumentList(): this.network().getPolicyList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.isFulfilled?
        this.network().getPolicyDocumentList(): this.network().getPolicyList()
    },
    addStutus(title,content){
      this.statusList.push({
        title,
        content
      })
    },
    delStatus(title,content){
      // 把符合删除条件的元素都过滤掉
      let arr = []
      arr = this.statusList.filter(item => {
        return item.title !== title
      })
      this.statusList = JSON.parse(JSON.stringify(arr))
    },
    resetFilter(){
      Object.keys(this.defaultFilter).forEach(key => {
        this[key] = this.defaultFilter[key]
      })
      this.filterData()
    },
    toQuoteList(){
      let params = {
        stts: [9]
      }
      this.setFilterData({quote:params})
      this.$router.push({
        path: '/records/quote'
      })
    },
    toQuoteMobileList(){
      let params = {
        stts: [1],
        product_id:[93],
        effe:[],
        has_img:1
      }
      this.setFilterData({micropolicy:params})
      this.$router.push({
        path: '/records/micropolicy'
      })
    },
    network() {
      return {
        getPolicyList: async () => {
          // 處理 product_id
          // let productId = [...this.product_id]
          // if(productId.includes(1500)) {
          //   productId = [
          //     ...productId,
          //     1501,
          //     1502
          //   ]
          // }
          // if(productId.includes(1200)) {
          //   productId = [
          //     ...productId,
          //     1201,
          //     1202,
          //     1203
          //   ]
          // }
          let params = {
            created_start: this.date?this.date[0]:null,
            created_end: this.date?this.date[1]:null,
            class_id: this.class_id,
            company_id: this.company_id,
            stts: this.stts,
            cs_id: this.cs_id,
            search: this.search,
            page: this.pageConfig.currentPage,
            tag_id: this.tags,
            renew_status: this.renew_status,
            effe_id: this.effe,
            source: this.source,
            search_type:this.search_type,
            partner_filter_id: this.partner_filter_id,
            referrer_code: this.referrer_code,
            cmnt_dt: this.effective_date?this.effective_date[0]:null,
            expry_dt: this.effective_date?this.effective_date[1]:null,
            start_expry_dt : this.effective_end_date?this.effective_end_date[0]:null,
            end_expry_dt : this.effective_end_date?this.effective_end_date[1]:null,
            order_by_data:this.sort==1?'updated_at':'sort_time',
            order_by_sort:'desc',
            merchant_platform:this.merchant_platform,
            agency_search_id:this.agency_search_id,
            user_agreement_1:this.user_agreement_1,
            pcy_agreement_1:this.pcy_agreement_1,
            hav_account:this.hav_account,
            auto_renewal_tag: this.auto_renewal_tag,
            auto_renewal: this.auto_renewal ,
          }
          if(this.isSelectPrivate){
            params.search_class_id =this.selectPrivateOrAll
          }
          if(this.selectPrivateOrAll==11){
            params.extra_benefit_arr = this.extra_benefit_arr
          }
          if(this.selectPrivateOrAll==23){
            params.plan_type=this.plan_type
          }
          const { data } = await getPolicyList(params,this.isSelectPrivate)
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getPolicyDocumentList: async () => {
          let params ={
            // pcy_cmnt_dt: this.date[0],
            // pcy_expry_dt: this.date[1],
            created_start: this.date?this.date[0]:null,
            created_end:  this.date?this.date[1]:null,

            class_id: this.class_id,
            company_id: this.company_id,
            stts: this.stts,
            renew_status: this.renew_status,
            cs_id: this.cs_id,
            search_type:this.search_type,
            search: this.search,
            page: this.pageConfig.currentPage,
            source: this.source,
            partner_filter_id: this.partner_filter_id,
            referrer_code: this.referrer_code,
            cmnt_dt: this.effective_date?this.effective_date[0]:null,
            expry_dt: this.effective_date?this.effective_date[1]:null,
            start_expry_dt : this.effective_end_date?this.effective_end_date[0]:null,
            end_expry_dt : this.effective_end_date?this.effective_end_date[1]:null,
            merchant_platform:this.merchant_platform,
            agency_search_id:this.agency_search_id,
            user_agreement_1:this.user_agreement_1,
            pcy_agreement_1:this.pcy_agreement_1,
            tag_id: this.tags,
            hav_account: this.hav_account,
            auto_renewal_tag: this.auto_renewal_tag,
            auto_renewal: this.auto_renewal ,
          }
          if(this.selectPrivateOrAll==11){
            params.extra_benefit_arr = this.extra_benefit_arr
          }
          if(this.selectPrivateOrAll==23){
            params.plan_type=this.plan_type
          }
          const { data } = await getPolicyDocumentList(params)
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getPolicyExportList: async () => {
          let params ={
            created_start: this.date?this.date[0]:'',
            created_end: this.date?this.date[1]:'',
            class_id: this.class_id,
            company_id: this.company_id,
            stts: this.stts,
            search_type:this.search_type,
            renew_status: this.renew_status,
            cs_id: this.cs_id,
            search: this.search,
            source: this.source,
            partner_filter_id: this.partner_filter_id,
            cmnt_dt:this.effective_date?this.effective_date[0]:'',
            expry_dt: this.effective_date?this.effective_date[1]:'',
            start_expry_dt : this.effective_end_date?this.effective_end_date[0]:'',
            end_expry_dt : this.effective_end_date?this.effective_end_date[1]:'',
            merchant_platform:this.merchant_platform,
            agency_search_id:this.agency_search_id,
            user_agreement_1:this.user_agreement_1,
            pcy_agreement_1:this.pcy_agreement_1,
            referrer_code: this.referrer_code,
            tag_id: this.tags,
            hav_account: this.hav_account,
            auto_renewal_tag: this.auto_renewal_tag,
            auto_renewal: this.auto_renewal ,

            effe_id: this.effe,
            order_by_data:this.sort==1?'updated_at':'sort_time',
            order_by_sort:'desc',
          }
          if(this.isSelectPrivate){
            params.search_class_id =this.selectPrivateOrAll
            delete params.class_id
          }
          if(this.selectPrivateOrAll==23){
            params.plan_type=this.plan_type
          }
          if(this.selectPrivateOrAll==11){
            params.extra_benefit_arr = this.extra_benefit_arr
          }
          let {data} =  await getPolicyExportList(params,this.isSelectPrivate)
          let {message}=data
          this.$message({
            type: 'success',
            message: message
          })
          // downloadFile(res)
        },
        getOrderList: async () => {
          const { data } = await getOrderList({
            stts: [9],
          })
          this.paymentNum = data.total
        },
        getOrderMoibleList: async () => {
          const { data } = await getMicropolicyList({
            stts: [1],
            product_id:[93],
            has_img:1
          })
          this.paymentMobileNum = data.total
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .mg-r-5{
    margin-right: 5px;
  }
  .flex-algin {
    /*display: flex;*/
    /*flex-direction: column;*/
    //justify-content: space-between;
    //font-weight: 500;
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      display: flex;
      flex-direction: column;
      span{
        font-size: 12px;
      }
      .asap{
        font-weight: bold;
        color: black;
        margin-left: 5px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;

    }
    .summary_rgtn_no{
      color: #6A737D;
      font-size: 12px;
      border: 1px solid #6A737D;
      border-radius: 4px;
      padding: 2px 4px;
    }
    .status-height{
      height: 23px;
    }
  }
  .channel{
    font-size: 12px;
    font-weight: 600;
    color: #586069;
  }

  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .box-show__none{
    box-shadow: none;
    border: 1px solid #D1D5DA;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }

  }
  .span-name {
    display: block;
    color: #24292E;
    height: auto!important;
    font-size: 14px;
    word-break: break-word;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 600;
    word-break: break-word;
    font-size: 14px;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .half {
    flex: 1;
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
    /deep/.el-checkbox{
      .el-checkbox__label{
        font-size: 12px;
        color: #24292E;
      }
    }
  }
  .span-status, .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.pending_verify{
      /*padding: 0 8px;*/
      font-size: 12px;
      background: #FFFFFF;
      /*border-radius: 100px;*/
      line-height: 20px;
      white-space: nowrap;
      /*border: 1px solid #dbab09;*/
      color: #dbab09;
    }
    &.not_verify{
      /*padding: 0 8px;*/
      font-size: 12px;
      background: #fff;
      /*border-radius: 100px;*/
      line-height: 20px;
      white-space: nowrap;
      /*border: 1px solid #d73a49;*/
      color: #d73a49;
    }
    &.verified{
      /*padding: 0 8px;*/
      font-size: 12px;
      background: #FFFFFF;
      /*border-radius: 100px;*/
      line-height: 20px;
      white-space: nowrap;
      /*border: 1px solid #22863a;*/
      color: #22863a;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &__none{
      border: none;
    }
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
    &.yellow-dark {
      border-color: #DBAB09;
      color: #DBAB09;
    }
  }
  .span-options-2{
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.big-red {
      border-color: $del;
      color: $del;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .payment-tips{
    width: 100%;
    height: 64px;
    background: #FFFBDD;
    border: 1px solid rgba(176, 136, 0, 0.2);
    border-radius: 6px;
    color: #24292E;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    &__top{
      padding:5px 0;
      height: auto;
      margin: 0 8px;
    }
    .tips-icon{
      color: #B08800;
    }
    .left{
      padding-left: 16px;
      .tips-icon{
        margin-right: 16px;
      }
    }
    .right{
      padding-right: 18px;
    }
  }
  .filter-top {
    margin-bottom: 14px;
  }
  .filter-bar{
    border: 1px solid #D1D5DA;
    height: 46px;
    padding: 11px 16px;
    background: #FFFFFF;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    .icon{
      font-weight: 900;
      font-size: 14px;
      color: #586069;
    }
    .main-left{
      display: flex;
      overflow: hidden;
    }
    .left{
      margin-right: 15px;
      .icon-filter{
        margin-right: 11px;
      }
      .text{
        font-weight: 600;
        font-size: 14px;
      }
    }
    .filter-status{
      .status-item{
        height: 24px;
        padding: 4px 8px;
        background: #F1F8FF;
        border-radius: 100px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #0366D6;
        .content{
          font-weight: 600;
        }
        & + .status-item{
          margin-left: 18px;
        }
      }
    }
    .right{
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 16px;
      .translucence{
        position: absolute;
        right: 100%;
        width: 15px;
        height: 44px;
        background: linear-gradient(90deg, rgba(219, 237, 255, 0) 0%, #DBEDFF 100%);
      }
      .right-cotent{
        background: #DBEDFF;
      }
      .icon-rotate{
        margin-right: 18px;
        color: #0366D6;
      }
    }
    &.blue-bg{
      background: #DBEDFF;
    }
  }
  .border-bottom-radius{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .filter-card {
    margin-bottom: 15px;
    background: white;
    border: 1px solid #E1E4E8;
    border-top: none;
    .filter-main {
      display: flex;
      padding: 0 15px;
      overflow-x: auto;
      .form-item{
        white-space: nowrap;
        /deep/.el-checkbox__label{
          white-space: nowrap;
        }
      }
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right, .filter-last {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 350px;
        flex: 1;

      }
      .left-border{
        border-left: 1px solid #E1E4E8;
      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        //border-right: 1px solid #E1E4E8;
        flex: 2;
      }
      .filter-right {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
      .filter-last{
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }

      &.red {
        background: #D73A49;
      }
    }
  }
  .purple {
    background: #6F42C1;
  }
}
.transparent{
  margin-top: 15px;
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 23px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
      }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.showLick{
  text-decoration: none;
}
/deep/.has-company-icon{
  .el-select-dropdown__item{
    height: 34px!important;
  }
}
.circle {
  display: inline-block;
  margin-right: 5px;
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  border-radius: 100%;
  &.orange-light {
    background: #E36209;
  }
  &.yellow-dark {
    background: #DBAB09;
  }
  &.blue {
    background: #0366D6;
  }
  &.gray {
    background: #586069;
  }
  &.green {
    background: #28A745;
  }

  &.red {
    background: #D73A49;
  }
}
.table-icon__img{
  width: 22px;
  display: block;
  img{
    width: 22px;
  }
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
.flex-platform{
  .v-radio-group{
    width: 230px;
  }
  .table-icon__img{
    width: 12px;
    height: 12px;
    margin-right: 4px;
    img{
      width: 12px;
      height: 12px;
    }
  }
}
.display-flex{
  display: flex!important;
}
/deep/.el-time-spinner__wrapper:nth-child(3) {
  display: none;
}
/deep/.el-date-editor--datetimerange.el-input__inner {
  width: 335px;
}
</style>
